import type { FC } from 'react';

import { withPreferredLocation } from 'src/app/hocs';
import type { LOCATIONS } from 'src/consts';

type LocationKeys = keyof typeof LOCATIONS;
type LocalizeChildren = { [key in LocationKeys]: any };

interface LocalizeProps {
  preferredLocation: LocationKeys;
  children: LocalizeChildren;
}

const BaseComponent = ({ preferredLocation, children }: LocalizeProps) => {
  return <>{children[preferredLocation]}</>;
};

// @ts-ignore
export const Localize: FC<{ children: LocalizeChildren }> = withPreferredLocation(BaseComponent);
